import { PosterImage } from '@elements/poster-image'
import { imageOptimize } from '@utils/images'

export function EventShowBill({
  posterSrc,
  name,
}: { posterSrc?: string; name: string }) {
  const backgroundSrc = imageOptimize(posterSrc, {
    w: '500',
    h: '750',
    dpr: '0.5',
    q: '20',
  })

  if (!posterSrc) return null
  return (
    <div className='relative z-0 flex items-center justify-center h-full'>
      <div
        className='absolute inset-0 z-0 w-full h-full scale-110 bg-center bg-no-repeat bg-cover blur-md'
        style={{ backgroundImage: `url(${backgroundSrc})` }}
      ></div>
      <PosterImage
        src={posterSrc}
        loading='eager'
        w='auto'
        h='auto'
        dpr='0.5'
        q='50'
        fill='solid'
        bg='transparent'
        alt={name}
        className='mx-auto z-[1] max-w-sm md:max-w-full max-h-full min-h-[480px]'
      />
    </div>
  )
}
